import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue";
var _hoisted_1 = ["title"];
var _hoisted_2 = {
  "class": "media align-items-center"
};
var _hoisted_3 = {
  "class": "avatar avatar-sm rounded-circle"
};
var _hoisted_4 = ["alt", "src", "title"];
var _hoisted_5 = {
  key: 2,
  "class": "btn btn-sm btn-primary",
  role: "button",
  href: "/reg"
};

var _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  "class": "dropdown-header noti-title"
}, [/*#__PURE__*/_createElementVNode("h6", {
  "class": "text-overflow m-0"
}, "Welcome!")], -1);

var _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  "class": "dropdown-divider"
}, null, -1);

var _hoisted_8 = /*#__PURE__*/_createElementVNode("i", {
  "class": "ni ni-user-run"
}, null, -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_base_dropdown = _resolveComponent("base-dropdown");

  var _component_login = _resolveComponent("login");

  var _component_modal = _resolveComponent("modal");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_base_dropdown, {
    "class": "nav-item",
    position: "right"
  }, {
    title: _withCtx(function () {
      return [$data.isLogin ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        "class": "nav-link",
        role: "button",
        title: $data.userName
      }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, [_createElementVNode("img", {
        alt: $data.userName,
        src: $data.headImg,
        title: $data.userName
      }, null, 8, _hoisted_4)])])], 8, _hoisted_1)) : _createCommentVNode("", true), !$data.isLogin ? (_openBlock(), _createElementBlock("a", {
        key: 1,
        "class": "btn btn-sm btn-primary",
        role: "button",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return $data.showLoginModel = true;
        })
      }, _toDisplayString(_ctx.$t("button.login")), 1)) : _createCommentVNode("", true), !$data.isLogin ? (_openBlock(), _createElementBlock("a", _hoisted_5, _toDisplayString(_ctx.$t("button.register")), 1)) : _createCommentVNode("", true)];
    }),
    "default": _withCtx(function () {
      return [_hoisted_6, _hoisted_7, _createElementVNode("a", {
        "class": "dropdown-item",
        onClick: _cache[1] || (_cache[1] = function () {
          return $options.logout && $options.logout.apply($options, arguments);
        })
      }, [_hoisted_8, _createElementVNode("span", null, _toDisplayString(_ctx.$t("login.loginout")), 1)])];
    }),
    _: 1
  }), _createVNode(_component_modal, {
    show: $data.showLoginModel,
    "body-classes": "p-0",
    "modal-classes": "modal-dialog-centered modal-sm"
  }, {
    "default": _withCtx(function () {
      return [_createVNode(_component_login, {
        onOnLoginScuccess: $options.loginScuccess,
        isHaveKeychain: $data.isHaveKeychain
      }, null, 8, ["onOnLoginScuccess", "isHaveKeychain"])];
    }),
    _: 1
  }, 8, ["show"])], 64);
}